import { render, staticRenderFns } from "./PeriodRiskSpread.vue?vue&type=template&id=0990f006&scoped=true&"
import script from "./PeriodRiskSpread.vue?vue&type=script&lang=js&"
export * from "./PeriodRiskSpread.vue?vue&type=script&lang=js&"
import style0 from "./PeriodRiskSpread.vue?vue&type=style&index=0&id=0990f006&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0990f006",
  null
  
)

export default component.exports